// reducers/connect/index.js

import { combineReducers }              from 'redux';
import { connectChat }                  from './chat';
import { connectChatHasErrored }        from './chat';
import { connectChatIsLoading }         from './chat';
import { connectSources }               from './sources';
import { connectSourcesHasErrored }     from './sources';
import { connectSourcesIsLoading }      from './sources';
import { connectSourcesSave }           from './save';
import { connectSourcesSaveHasErrored } from './save';
import { connectSourcesSaveIsLoading }  from './save';
import { connectInstances }             from './instances';
import { connectInstancesHasErrored }   from './instances';
import { connectInstancesIsLoading }    from './instances';
import { connectToken }                 from './token';
import { connectTokenHasErrored }       from './token';
import { connectTokenIsLoading }        from './token';
import { connectDisconnect }            from './disconnect';
import { connectDisconnectHasErrored }  from './disconnect';
import { connectDisconnectIsLoading }   from './disconnect';
import { connectFeedback }              from './feedback';
import { connectFeedbackHasErrored }    from './feedback';
import { connectFeedbackIsLoading }     from './feedback';
import { connectRegister }              from './register';
import { connectRegisterHasErrored }    from './register';
import { connectRegisterIsLoading }     from './register';
import { connectOffline }               from './offline';
import { connectOfflineHasErrored }     from './offline';
import { connectOfflineIsLoading }      from './offline';
import { cannedResponsesGet}            from './cannedResponses';
import { cannedResponsesGetHasErrored}  from './cannedResponses';
import { cannedResponsesGetIsLoading}   from './cannedResponses';
import { cannedResponsesAdd}            from './cannedResponses';
import { cannedResponsesAddHasErrored}  from './cannedResponses';
import { cannedResponsesAddIsLoading}   from './cannedResponses';
import { cannedResponsesUpdate}            from './cannedResponses';
import { cannedResponsesUpdateHasErrored}  from './cannedResponses';
import { cannedResponsesUpdateIsLoading}   from './cannedResponses';
import { cannedResponsesDelete}            from './cannedResponses';
import { cannedResponsesDeleteHasErrored}  from './cannedResponses';
import { cannedResponsesDeleteIsLoading}   from './cannedResponses';

const connectChatReducers = combineReducers({
  connectChat,
  connectChatHasErrored,
  connectChatIsLoading
});

const connectSourcesReducers = combineReducers({
  connectSources,
  connectSourcesHasErrored,
  connectSourcesIsLoading
});

const connectSourcesSaveReducers = combineReducers({
  connectSourcesSave,
  connectSourcesSaveHasErrored,
  connectSourcesSaveIsLoading
});

const connectInstancesReducers = combineReducers({
  connectInstances,
  connectInstancesHasErrored,
  connectInstancesIsLoading
});

const connectTokenReducers = combineReducers({
  connectToken,
  connectTokenHasErrored,
  connectTokenIsLoading
});

const connectDisconnectReducers = combineReducers({
  connectDisconnect,
  connectDisconnectHasErrored,
  connectDisconnectIsLoading
});

const connectFeedbackReducers = combineReducers({
  connectFeedback,
  connectFeedbackHasErrored,
  connectFeedbackIsLoading
});

const connectRegisterReducers = combineReducers({
  connectRegister,
  connectRegisterHasErrored,
  connectRegisterIsLoading
});

const connectOfflineReducers = combineReducers({
  connectOffline,
  connectOfflineHasErrored,
  connectOfflineIsLoading
});

const connectCannedReducers = combineReducers({
  cannedResponsesGet,
  cannedResponsesGetHasErrored,
  cannedResponsesGetIsLoading,
  cannedResponsesAdd,
  cannedResponsesAddHasErrored,
  cannedResponsesAddIsLoading,
  cannedResponsesUpdate,
  cannedResponsesUpdateHasErrored,
  cannedResponsesUpdateIsLoading,
  cannedResponsesDelete,
  cannedResponsesDeleteHasErrored,
  cannedResponsesDeleteIsLoading
});

export default combineReducers({
  connectChat: connectChatReducers,
  connectSources: connectSourcesReducers,
  connectSourcesSave: connectSourcesSaveReducers,
  connectInstances: connectInstancesReducers,
  connectToken: connectTokenReducers,
  connectDisconnect: connectDisconnectReducers,
  connectFeedback: connectFeedbackReducers,
  connectRegister: connectRegisterReducers,
  connectOffline: connectOfflineReducers,
  cannedResponses: connectCannedReducers
});